/*
 * Author: Harper Yan
 * File Created: Sunday, 25-01-19 02:50 pm
 * Last Modified: Thursday, 25-01-23 10:25 am, by Harper Yan
 */

function ArrowLeft() {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="ArrowLeft" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.6365 5.36358C15.988 5.71505 15.988 6.2849 15.6365 6.63637L10.2729 12L15.6365 17.3636C15.988 17.7151 15.988 18.2849 15.6365 18.6364C15.285 18.9878 14.7152 18.9878 14.3637 18.6364L8.3637 12.6364C8.01223 12.2849 8.01223 11.7151 8.3637 11.3636L14.3637 5.36358C14.7152 5.01211 15.285 5.01211 15.6365 5.36358Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default ArrowLeft;